import {
  COMPANY_SIZE_OPTIONS,
  INDUSTRY_OPTIONS,
  REFERRAL_SOURCE_OPTIONS,
  ROLE_OPTIONS,
  SELECT_INPUT_OTHER_VALUE,
  TEAM_OPTIONS
} from "@/src/common/business-layer/constants"
import { InferType, object, string } from "yup"

export const AccountDetailsSchema = object({
  role: string()
    .required()
    .oneOf(
      ROLE_OPTIONS.map((option) => option.value),
      "${label} must be one of the available options"
    )
    .label("Role"),
  roleOther: string()
    .when("role", {
      is: SELECT_INPUT_OTHER_VALUE,
      then: (schema) => schema.required("Please specify your role"),
      otherwise: (schema) => schema.notRequired()
    })
    .label("Role"),
  team: string()
    .required()
    .oneOf(
      TEAM_OPTIONS.map((option) => option.value),
      "${label} must be one of the available options"
    )
    .label("Team"),
  teamOther: string()
    .when("team", {
      is: SELECT_INPUT_OTHER_VALUE,
      then: (schema) => schema.required("Please specify your team"),
      otherwise: (schema) => schema.notRequired()
    })
    .label("Team"),
  dialingCode: string().required("Country code is required"),
  phoneNumber: string()
    .required()
    .matches(/^[0-9]+$/, { message: "${label} must be only digits" })
    .min(7, "${label} must be at least ${min} digits")
    .max(15, "${label} must be at most ${max} digits")
    .label("Phone number"),
  city: string().required().label("City"),
  country: string().required().label("Country"),
  companyName: string().label("Company name"),
  industry: string().label("Industry"),
  industryOther: string()
    .when("industry", {
      is: SELECT_INPUT_OTHER_VALUE,
      then: (schema) => schema.required("Please specify your industry"),
      otherwise: (schema) => schema.notRequired()
    })
    .label("Industry"),
  companySize: string().label("Number of employees"),
  referralSource: string().label("Referral source")
})

export const AccountDetailsWithOrganisationSchema = AccountDetailsSchema.shape({
  companyName: string().required().label("Company name"),
  industry: string()
    .required()
    .oneOf(
      INDUSTRY_OPTIONS.map((option) => option.value),
      "${label} must be one of the available options"
    )
    .label("Industry"),
  companySize: string()
    .required()
    .oneOf(
      COMPANY_SIZE_OPTIONS.map((option) => option.value),
      "${label} must be one of the available options"
    )
    .label("Number of employees"),
  referralSource: string()
    .required()
    .oneOf(
      REFERRAL_SOURCE_OPTIONS.map((option) => option.value),
      "${label} must be one of the available options"
    )
    .label("Referral source")
})

export const getAccountDetailsSchema = (includeOrganisation: boolean) =>
  includeOrganisation
    ? AccountDetailsWithOrganisationSchema
    : AccountDetailsSchema

export type AccountDetails = InferType<typeof AccountDetailsSchema>
